module.exports = __webpack_public_path__ + "img/points-of-sale.afdf51ce.svg";